import { updateSettingsProfileApi as generatedUpdateSettingsProfileApi } from '../generated/settingsProfile/updateSettingsProfile';

const updateProfileApi = generatedUpdateSettingsProfileApi.enhanceEndpoints({
  endpoints: {
    updateSettingsProfile: {
      invalidatesTags: ['SettingsProfile', 'Settings'],
    },
  },
});

export const { useUpdateSettingsProfileMutation } = updateProfileApi;
